import FileCopyIcon from '@mui/icons-material/FileCopy';
import {capitalize, Tooltip} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {useAufgabenHandling} from "../../hooks/aufgaben/useAufgabenHandling";

interface ButtonDuplicateAufgabeProps {
    aufgabeId: string;
}

export default function ButtonDuplicateAufgabe({
    aufgabeId,
}: ButtonDuplicateAufgabeProps) {
    const { translation, duplicateAufgabeMutation } = useAufgabenHandling();

    return (
        <Tooltip title={translation('duplicate')}>
            <LoadingButton
                id={`button-duplicate-aufgabe-${aufgabeId}`}
                aria-label={`button-duplicate-aufgabe-${aufgabeId}`}
                onClick={() => duplicateAufgabeMutation.mutate(aufgabeId)}
                loading={duplicateAufgabeMutation.isLoading}
                loadingPosition="start"
                startIcon={<FileCopyIcon />}
                variant="text"
                color="inherit"
            >
                {capitalize(translation('duplicate'))}
            </LoadingButton>
        </Tooltip>
    );
}
